module.exports = __webpack_public_path__ + "static/f-JHernandez-3ed8837e47fb1a3b20185160ca8a29aa.jpg";